// Mensagem de erro por campo; campo ausente = válido
export type ValidationErrors<TField extends string = string> = Partial<Record<TField, string>>;

export function isBlank(value?: string | null): boolean {
    return value === undefined || value === null || String(value).trim().length === 0;
}

// Selects e ids chegam como número, string ou vazio; 0 também significa "não selecionado"
export function isEmptyId(value?: number | string | null): boolean {
    return value === undefined || value === null || value === '' || Number(value) === 0 || Number.isNaN(Number(value));
}

export function hasErrors(errors: ValidationErrors | Record<string, boolean | string | undefined>): boolean {
    return Object.values(errors).some(Boolean);
}
